import client from "./client";

export const listCountries = async () => (await client.get("/documents/countries")).data;
export const expiringDocuments = async (days = 60) =>
  (await client.get("/documents/expiring", { params: { days } })).data;
export const uploadDocument = async (file, kind) => {
  const data = new FormData();
  data.append("file", file);
  data.append("kind", kind);
  const res = await client.post("/documents/upload", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const downloadEmployeePdf = async (userId, lang = "ar") => {
  const res = await client.get(`/documents/employee/${userId}/pdf`, { params: { lang }, responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
  const link = document.createElement("a");
  link.href = url;
  link.download = "employee-profile.pdf";
  link.click();
  window.URL.revokeObjectURL(url);
};
